import { render, staticRenderFns } from "./course8.vue?vue&type=template&id=558c0f92&scoped=true&"
import script from "./course8.vue?vue&type=script&lang=js&"
export * from "./course8.vue?vue&type=script&lang=js&"
import style0 from "./course8.vue?vue&type=style&index=0&id=558c0f92&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c0f92",
  null
  
)

export default component.exports